// extracted by mini-css-extract-plugin
export default {"banner":"UpgradePlanCard_banner__5voQp","callout":"UpgradePlanCard_callout__XNNmZ"};